module.exports = __webpack_public_path__ + "static/media/profile.12d4b262.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/sections/about/profile.jpg
// module id = 59
// module chunks = 0